<template>
  <div class="flex flex-col overflow-y-hidden min-h-screen">
    <!-- <div class="page-transition-overlay"></div> -->


    <header>
      <nav>
        <Navbar />
      </nav>
    </header>
    <main
      class="min-h-screen w-full"
    >

      <slot />
    </main>
    <footer>
      <Footer />
    </footer>
  </div>
</template>

<script>
import Footer from '~/components/layouts/Footer.vue';
import Navbar from '~/components/layouts/Navbar.vue';

export default {
  name: 'DefaultLayout',
  components: {
    Navbar,
    Footer
  },

};
</script>

<style>

.page-transition-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--p-background-0); /* Oslo sitesindeki siyah overlay */
  z-index: 9999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}
</style>